import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-pds-misutilization',
  templateUrl: './pds-misutilization.component.html',
  styleUrls: ['./pds-misutilization.component.scss']
})
export class PdsMisutilizationComponent implements OnInit{
pdsForm!:FormGroup;
UserDetails:any;

     constructor(private reportService: ReportsService,private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {
    
      }
  
       ngOnInit(): void {
      
          this.pdsForm = this.fb.group({
            financialYear: ['', Validators.required],
            blockOffice: ['', Validators.required],
      
          });
      
        
          let user: any = this.authService.currentUserValue;
          this.UserDetails = user;
         
       
  
          

        }
}
